import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import './StatisticsSection.css';

const StatisticsSection = ({
  stats = [],
  heading = 'The Numbers Behind Our Purpose',
  description = '',
  backgroundImage = '',
}) => {
  const { ref, inView } = useInView({ triggerOnce: false, threshold: 0.3 });

  return (
    <section
      className="statistics-section "
      style={{ backgroundImage: `url(${backgroundImage})` }}
      ref={ref}
    >
      <div>
        <h2 className="statistics-heading ">{heading}</h2>
        <div className="statistics-grid container">
          {stats.map((stat, idx) => (
            <div className="stat-item" key={idx}>
              <span className="stat-number">
                <CountUp
                  end={stat.value}
                  duration={2}
                  suffix={stat.suffix || ''}
                  start={inView ? undefined : 0}
                  redraw={true}
                />
              </span>
              <span className="stat-label">{stat.label}</span>
            </div>
          ))}
          {description && (
            <div className="statistics-desc-cell">
              <div className="statistics-desc">{description}</div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default StatisticsSection; 